import { Injectable } from '@angular/core';
import { StaffClinic } from '../../domain/models/staff-clinic.model';
import { StaffClinicDto } from '../dtos/staff-clinic.dto';

@Injectable({ providedIn: 'root' })
export class StaffClinicMapper {
  public toStaffClinic(dto: StaffClinicDto): StaffClinic {
    return {
      organizationId: dto.OrganizationId,
      organizationName: dto.OrganizationName,
      logoUrl: dto.LogoUrl,
      status: dto.Status,
      isDefault: dto.IsDefault,
      isSuspended: dto.IsSuspended,
      lastAccessedAtUtc: dto.LastAccessedAtUtc,
      pendingInvitationId: dto.PendingInvitationId,
    };
  }
}
